import { Buttonbarmypr } from "./Buttonbar_mypr";
import { Myproject } from "./Myproject"


export const Projectpage = () => {
    return (
        <>
            <Buttonbarmypr />
            <Myproject />
            <Myproject />
            <Myproject />
        </>
    );
}